import { gql } from "@apollo/client";

export const getPaymentCollectionData = gql`
 query GetPaymentBalanceCustomerCode(
    $customerCode: String!
    $repcode: String!
  ) {
    getPaymentBalanceCustomerCode(
      customerCode: $customerCode
      repCode: $repcode
    ) {
      success

      error

      message

      data {
        customerCode

        customerName

        repCode
         ageOfInvoice
        ndays
        repName

        creditLimit

        category

        totalBalance

        status

        invoices {
          id

          invoiceNumber

          soDate

          balance

          paymentStatus

          partialPaidAmount

          remainingAmount

          remarks
        }
      }
    }
  }
`;

export const submitPaymentCollectionData = gql`
  mutation CreateReceiptAndUpdatePayments(
    $input: CreateReceiptAndUpdatePaymentsInput!
  ) {
    createReceiptAndUpdatePayments(input: $input) {
      success
      error
      message
      receiptNumber
    }
  }
`;
